// AUTO-GENERATED by generate-rxdb-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { defaultHooks } from '../defaults'

const name = 'milestones'

/**
 * Milestone Model Interface (auto-generated from Drizzle schema)
 */
export interface MilestoneModel {
  id: string
  orgId: string
  workspaceId: string
  userId?: string
  createdAt: string
  updatedAt: string
  metadata?: Record<string, unknown>
  extended?: Record<string, unknown>
  name?: string
  title: string
  description?: string
  completed: boolean
  status?: string
  sortOrder: number
  projectId: string
  goalId: string
  startAt?: string
  startedAt?: string
  dueAt?: string
  completedAt?: string
  archived: boolean
  timeBudgetHours?: number
  categoryId?: string
  tagIds?: string[]
  version: number
  mentions?: unknown[]
  tenantId?: string
}

export const schema = {
  title: name,
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
      maxLength: 100,
    },
    orgId: {
      type: 'string',
      maxLength: 100,
    },
    workspaceId: {
      type: 'string',
      maxLength: 100,
    },
    userId: {
      type: 'string',
      maxLength: 100,
    },
    createdAt: {
      type: 'string',
      maxLength: 200,
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      maxLength: 200,
      format: 'date-time',
    },
    metadata: {
      type: 'object',
    },
    extended: {
      type: 'object',
    },
    name: {
      type: 'string',
      maxLength: 500,
    },
    title: {
      type: 'string',
      maxLength: 500,
    },
    description: {
      type: 'string',
      maxLength: 100000,
    },
    completed: {
      type: 'boolean',
    },
    status: {
      type: 'string',
      maxLength: 50,
    },
    sortOrder: {
      type: 'integer',
      minimum: 0,
      maximum: 999999,
      multipleOf: 1,
    },
    projectId: {
      type: 'string',
      maxLength: 100,
    },
    goalId: {
      type: 'string',
      maxLength: 100,
    },
    startAt: {
      type: 'string',
      maxLength: 200,
      format: 'date-time',
    },
    startedAt: {
      type: 'string',
      maxLength: 200,
      format: 'date-time',
    },
    dueAt: {
      type: 'string',
      maxLength: 200,
      format: 'date-time',
    },
    completedAt: {
      type: 'string',
      maxLength: 200,
      format: 'date-time',
    },
    archived: {
      type: 'boolean',
    },
    timeBudgetHours: {
      type: 'number',
    },
    categoryId: {
      type: 'string',
      maxLength: 100,
    },
    tagIds: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
    version: {
      type: 'integer',
    },
    mentions: {
      type: 'array',
      items: {},
    },
    tenantId: {
      type: 'string',
      maxLength: 100,
    },
  },
  required: [
    'id',
    'orgId',
    'createdAt',
    'updatedAt',
    'title',
    'completed',
    'projectId',
    'goalId',
    'archived',
    'version',
    'workspaceId',
    'sortOrder',
  ],
  indexes: [
    ['orgId', 'createdAt'],
    ['orgId', 'workspaceId', 'createdAt'],
    ['workspaceId', 'createdAt'],
    ['projectId', 'createdAt'],
    ['projectId', 'sortOrder'],
  ],
}

export const migrationStrategies = {}

export const Collection = {
  name,
  schema,
  hooks: {
    ...defaultHooks({ name }),
  },
  migrationStrategies,
}
